module.exports = __webpack_public_path__ + "static/media/singleplayer.a9fc9187.svg";